module.exports = __webpack_public_path__ + "static/media/HCMM857.da73b7ff.jpg";